import $ from 'jquery';
import Parallax from 'parallax-js';
import Vide from '../vendor/vide.js';

class Header {

	constructor(element) {
		var scene = $('[data-paralax]').each((index,el) => this.load(el));
	}

	load(el) {
		var parallaxInstance = new Parallax(el);
	}

}

new Header